import * as React from "react"
import {
  ThemeCss,
  Card,
  Link,
  EmptyState,
  EmptyStateSecondaryAction,
} from "gatsby-interface"
import { SiteFunctionEntry } from "@modules/graphql/types"
import { getPathToBuildFunction } from "@modules/site/details/utils"
import { functionsView as text } from "@modules/locales/default"
import { LambdaGraphic } from "../assets/LambdaGraphic"

export type BuildFunctionsListProps = {
  buildId: string
  siteId: string
  organizationId: string
  functionsForSite: SiteFunctionEntry[]
}

export function BuildFunctionsList({
  buildId,
  siteId,
  organizationId,
  functionsForSite,
}: BuildFunctionsListProps) {
  if (!functionsForSite) {
    return null
  }

  if (functionsForSite.length === 0) {
    return (
      <EmptyState
        heading={text.headers.youDidntIncludeAnyFunctions}
        text={text.messages.youCanDevelopTestAndDeploy}
        graphic={<LambdaGraphic />}
        secondaryAction={
          <EmptyStateSecondaryAction
            href="/docs/reference/functions/"
            target="_blank"
          >
            {text.actions.readDocs}
          </EmptyStateSecondaryAction>
        }
      />
    )
  }

  return (
    <Card>
      <ul css={listCss}>
        {functionsForSite.map(({ id, path, status }) => {
          return (
            <li key={id} css={itemCs}>
              <Link
                to={`${getPathToBuildFunction({
                  functionId: id,
                  buildId,
                  siteId,
                  organizationId,
                })}/details`}
                css={linkCss}
              >
                {path}
              </Link>
            </li>
          )
        })}
      </ul>
    </Card>
  )
}

/* styles */

const listCss: ThemeCss = theme => ({
  listStyle: `none`,
  margin: 0,
  padding: 0,
  borderRadius: theme.radii[2],
  overflow: `hidden`,
})

const itemCs: ThemeCss = theme => ({
  margin: 0,

  "&:not(:last-of-type)": {
    borderBottom: `1px solid ${theme.colors.grey[10]}`,
  },
})

const linkCss: ThemeCss = theme => ({
  textDecoration: `none`,
  display: `block`,
  padding: `${theme.space[5]} ${theme.space[7]}`,
  fontWeight: theme.fontWeights.semiBold,

  "&:hover": {
    textDecoration: `none`,
    backgroundColor: theme.colors.purple[5],
  },
})
